import { Component, OnInit, Input } from '@angular/core';
import { ConfigurationService } from '../../../configuration/shared/services/configuration.service';
import { Configuration } from '../../../configuration/shared/classes/configuration';
import { TRANSLATE } from '../../classes/translatable';
import { AlertService } from '../../services/alert.service';
import { AclAccess } from '../../../configuration/shared/classes/acl_access';
import { StorageService } from '../../services/storage.service';

@Component({
  selector: 'app-admin-agenda',
  templateUrl: './admin-agenda.component.html',
  styleUrls: ['./admin-agenda.component.css']
})
export class AdminAgendaComponent implements OnInit {
    configuration: Configuration;

    aclConfig: AclAccess;

    @Input()
    triggerReload: () => void;

    constructor(
        private configService: ConfigurationService,
        private alertService: AlertService,
        private storageService: StorageService
    ) { }

    ngOnInit() {
        this.aclConfig  = new AclAccess(this.storageService.getAcl('configuration'));
        this.getConfiguration();
    }

    getConfiguration() {
        this.configService.getConfiguration()
            .subscribe(retour => {
                if (retour.status === 200) {
                    this.configuration = new Configuration(retour.data);
                }
        });
    }

    saveConfigurationAgenda() {
        this.configService.updateConfiguration(this.configuration)
        .subscribe(retour => {
            if (retour.status === 200) {
                this.alertService.success(TRANSLATE('Configuration mise à jour avec succès'));
                if (this.triggerReload) {
                    this.triggerReload();
                }
            } else {
                this.alertService.error(TRANSLATE(retour.message));
            }
        });
    }

}
